// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"A1-z","displaySixCardTiles":"B1-z"};